import {useContext} from 'react';
import Sidebar from '../../shared/Sidebar';
import {AuthContext} from '../../auth/useAuthContext';
import Loader from '../../shared/Loader';

const withSidebar = (WrappedComponent: any) => ({ ...props }) => {
  const { state } = useContext(AuthContext);

  return (
    <div className="c-dashboard">
      <Sidebar />
      {state.switchingBusiness ? <Loader /> :
        <section className="c-dashboard__layout">
          <div className="c-dashboard__container">
            <WrappedComponent {...props} />
          </div>
        </section>
      }
    </div>
  );
};

export default withSidebar;
